import React, {useContext} from 'react'
import {Link} from 'react-router-dom'
import AuthContext from '../../context/auth/AuthContext'
import HamburgerMenuSelect from './HamburgerMenuSelect'

export const DropdownContent = ({
  authenticated = false,
  hideOnResize,
  options,
}) => {
  const authContext = useContext(AuthContext)

  const {logout} = authContext

  const onClick = () => {
    logout()
  }

  let mobile = true // NOTE - for testing only (can set manually)

  return !authenticated ? (
    <div className='text-slate-800 leading-10 tracking-wide'>
      <Link to='/register'>
        <button className='w-full bg-emerald-500 p-5 rounded-full border-2 shadow-emerald-700 shadow-md border-emerald-200 text-slate-50 hover:bg-emerald-400 hover:text-emerald-800 hover:-translate-y-0.5 hover:border-emerald-500 transition-all'>
          Join Now!
        </button>
      </Link>
      <Link to='/login' className=''>
        <div className='mt-12 text-center border-y-orange-400 border-y-2'>
          Sign In
        </div>
      </Link>
    </div>
  ) : (
    <>
      <div className='text-slate-800 pl-1 leading-10 tracking-wide'>
        {options.map((item, index) => (
          <HamburgerMenuSelect key={index} {...item} />
        ))}
        <Link onClick={onClick} to=''>
          <div className='mt-12 text-center border-y-orange-400 border-y-2'>
            Sign Out
          </div>
        </Link>
      </div>
    </>
  )
}
